import { useNavigate } from "react-router-dom";
import { TodoServiceImpl } from "../../usecase/ServiceImpl";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setTodoCategoryList } from "../slice/Slice";

const Handler = (service: TodoServiceImpl) => {
    const navigate = useNavigate()
    const [countTodoTask, setCountTodoTask] = useState(0)
    const dispatch = useDispatch()
    const pathName = window.location.pathname;

    const goToTD001 = () => {
        if(pathName !== "/app-td001") return navigate("/app-td001")
    }

    const getTodoTaskNumber = async () => {
        const { total, todoCategoryList } = await service.getTodoTaskNumber()
        dispatch(setTodoCategoryList({
            total,
            todoCategoryList
        }))
        setCountTodoTask(total)
    }

    return {
        goToTD001,
        getTodoTaskNumber,
        countTodoTask
    }
}

export default Handler